import { datadogRum } from '@datadog/browser-rum-slim';

export default function useDatadog() {
    return {
        setUser: (userId: string) => {
            datadogRum.setUser({
                id: userId,
            });
        },
        removeUser: () => {
            datadogRum.clearUser();
        },
    };
}
